module.exports = __webpack_public_path__ + "img/facebookLight.1ea0b138.svg";